import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * MaxAssist partner configuration schema
 * Requires a single remote identifier for the practice.
 * No OAuth flow — configuration is complete once the remote_id is set.
 */
export const maxassistSchema: PartnerSchemaInternal = {
  partner: 'maxassist' as PartnerEnum,
  displayName: 'MaxAssist',
  fields: [
    {
      key: 'remote_id',
      label: 'Remote ID',
      type: 'text',
      required: true,
      helperText: 'MaxAssist remote identifier for the practice.',
    },
  ],
}
